import { toFrequencyOctaveOptions } from '@web/entities/measurement/lib/octave.logic'
import type { EDetectorType } from '@web/entities/measurement/model/enums/detector-type.enum'
import { EMagnitudeType } from '@web/entities/measurement/model/enums/magnitude-type.enum'
import {
  EFreqOctaveOne,
  EFreqOctaveThird,
  EFreqOctaveTwo,
  EOctaveType
} from '@web/entities/measurement/model/enums/octave.enum'
import type { ESpecterLineCount } from '@web/entities/measurement/model/enums/specter.enum'
import type { IOption } from '@web/shared/types/options.type'

export const octaveTypeOptions: Array<IOption<EOctaveType>> = [
  {
    value: EOctaveType.THIRD,
    label: '1/3'
  },
  {
    value: EOctaveType.ONE,
    label: '1'
  },
  {
    value: EOctaveType.TWO,
    label: '2'
  }
] as const

export const magnitudeTypeOptions: Array<IOption<EMagnitudeType>> = [
  {
    value: EMagnitudeType.RMS,
    label: 'СКЗ'
  },
  {
    value: EMagnitudeType.POWER,
    label: 'Мощность'
  }
]

export const frequencyOneOptions = toFrequencyOctaveOptions(EFreqOctaveOne)
export const frequencyTwoOptions = toFrequencyOctaveOptions(EFreqOctaveTwo)
export const frequencyThirdOptions = toFrequencyOctaveOptions(EFreqOctaveThird)

export const specterLineCountMap: { [key in ESpecterLineCount]: number } = {
  COUNT_8_100_128: 100,
  COUNT_7_200_256: 200,
  COUNT_6_400_512: 400,
  COUNT_5_800_1024: 800,
  COUNT_4_1600_2048: 1_600,
  COUNT_3_3200_4096: 3_200,
  COUNT_2_6400_8192: 6_400,
  COUNT_1_12800_16384: 12_800,
  COUNT_0_25600_32768: 25_600
} as const

export const specterLineCountOptions = Object.entries(specterLineCountMap)
  .map(([key, value]) => ({
    value: key as EDetectorType,
    label: value.toString(),
    number: value
  }))
  .sort((a, b) => b.number - a.number)
